// @flow
// TODO: Borrar
import React, { Fragment } from 'react';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
import { IdentityCard } from '../../IdentityCard';
import { ServiceDetailItem, Unsold, ButtonBlock, OrganizationWithCTA } from '../partials';

export const TaxDownDetail = ({ service, handleTransaction }: { service: Object, handleTransaction: Function }) => (
  <Fragment>
    {service.status === 'Unsold' ? (
      <Unsold>
        <p>
          {`Sentimos no poder ayudarte más, no hemos encontrado asesores que se ajusten a
          las necesidades que nos indicas. Quizá te resulte útil nuestra Guía de la Renta.`}
        </p>

        <ButtonBlock>
          <ButtonLined
            href={`https://www.finect.com/usuario/Josetrecet/articulos/renta_2016_las_casillas_clave_que_debes_rellenar_si_eres_inversor`}
            as="a"
            width="auto"
          >
            Acceder
          </ButtonLined>
        </ButtonBlock>
      </Unsold>
    ) : (
      <OrganizationWithCTA>
        {service.advisers.length > 0 &&
          service.advisers.map(item => (
            <ServiceDetailItem key={item.id}>
              <IdentityCard
                type="profile"
                entity={{
                  id: item.id,
                  subtype: item.subtype,
                  name: item.displayName,
                  icon: `/image/${item.icon}`,
                  alias: item.alias,
                  adviser: false,
                  company: 'Asesor',
                  verified: false
                }}
                isRefuse={service.status === 'MailedToUser'}
                onRefuse={() => handleTransaction(item, service.id)}
              />
            </ServiceDetailItem>
          ))}
        <ButtonBlock>
          <ButtonLined href={`https://taxdown.es/partners/finect/signup`} as="a" width="auto">
            Acceder
          </ButtonLined>
        </ButtonBlock>
      </OrganizationWithCTA>
    )}
  </Fragment>
);
